import { updateFinancePreapprovalAndTestDriveInfo } from "../services/dealership-user";
import { updateUserProfile } from "../services/dealership-user";
import { produce } from "immer";

export async function submitTestDriveApproval(
  userId,
  dealershipid,
  quizQuestions,
  setQuizQuestions
) {
  const financePreApprovalAndTestDriveObj = this.responses.call(this);

  console.log(financePreApprovalAndTestDriveObj, "test drive response obj");
  const response = await updateFinancePreapprovalAndTestDriveInfo(
    userId,
    financePreApprovalAndTestDriveObj
  );
  console.log(response, "response");
}

export async function submitUserUpdatedProfile(userId, dealershipId) {
  const updatedProfileResponses = this.responses.call(this);

  console.log(updatedProfileResponses, "updatedProfileResponses");

  const response = await updateUserProfile(
    userId,
    updatedProfileResponses,
    dealershipId
  );
  console.log(response, "response");
}
